import { connect } from 'react-redux';

import ComingSoon from '../components/pages/coming-soon';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const ComingSoonConnector = connect(mapStateToProps, mapDispatchToProps)(ComingSoon);

export default ComingSoonConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/coming-soon-connector.js
 **/